import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/store/modules/auth'
import common from '@/store/modules/common'
import japanese from '@/store/modules/japanese'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    common,
    japanese,
  },
})
